import React from "react";

const SubscriptionDot = ({ subscription, collectionPaused = false }) => {
  if(!subscription) return null;
  const status = subscription.status;
  let color = "bg-slate-400";
  if (["active","success"].includes(status)) {
    color = collectionPaused ? "bg-orange-400" : "bg-green-400";
  } else if (["trialing", "pending"].includes(status)) {
    color = "bg-blue-400";
  } else if (status === "past_due") {
    color = "bg-yellow-400";
  } else if (["canceled","failed"].includes(status)) {
    color = "bg-red-400";
  }
  return (
    <div
      className={`h-3 w-3 rounded-full ${color} inline-block`}
      title={status}
    ></div>
  );
}

export default SubscriptionDot;